/* Bask & Burrow — Guides Library client-side filtering.
   Progressive enhancement only: without this file, every card in
   bask-burrow-guides-library.liquid is simply visible as a plain grid.
   Load with `defer` in theme.liquid, after bask-burrow.css. */
(function () {
  var grid = document.querySelector('[data-bb-library-grid]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-bb-hub]'));
  var searchInput = document.querySelector('[data-bb-library-search]');
  var hubSelect = document.querySelector('[data-bb-library-filter="hub"]');
  var speciesSelect = document.querySelector('[data-bb-library-filter="species"]');
  var clearBtn = document.querySelector('[data-bb-library-clear]');
  var countEl = document.querySelector('[data-bb-library-count]');
  var emptyEl = document.querySelector('[data-bb-library-empty]');

  function currentState() {
    return {
      q: (searchInput && searchInput.value.trim().toLowerCase()) || '',
      hub: (hubSelect && hubSelect.value) || 'all',
      species: (speciesSelect && speciesSelect.value) || 'all'
    };
  }

  function applyFilters() {
    var state = currentState();
    var visibleCount = 0;

    cards.forEach(function (card) {
      var matchesHub = state.hub === 'all' || card.getAttribute('data-bb-hub') === state.hub;
      var matchesSpecies = state.species === 'all' || card.getAttribute('data-bb-species') === state.species;
      var matchesSearch = state.q === '' || card.getAttribute('data-bb-search').indexOf(state.q) !== -1;
      var visible = matchesHub && matchesSpecies && matchesSearch;
      card.hidden = !visible;
      if (visible) visibleCount++;
    });

    if (countEl) {
      countEl.textContent = visibleCount + (visibleCount === 1 ? ' guide' : ' guides');
    }
    if (emptyEl) {
      emptyEl.hidden = visibleCount !== 0;
    }

    var params = new URLSearchParams();
    if (state.q) params.set('q', state.q);
    if (state.hub !== 'all') params.set('hub', state.hub);
    if (state.species !== 'all') params.set('species', state.species);
    var query = params.toString();
    var newUrl = window.location.pathname + (query ? '?' + query : '');
    window.history.replaceState(null, '', newUrl);
  }

  function restoreFromUrl() {
    var params = new URLSearchParams(window.location.search);
    if (searchInput && params.has('q')) searchInput.value = params.get('q');
    if (hubSelect && params.has('hub')) hubSelect.value = params.get('hub');
    if (speciesSelect && params.has('species')) speciesSelect.value = params.get('species');
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters);
  if (hubSelect) hubSelect.addEventListener('change', applyFilters);
  if (speciesSelect) speciesSelect.addEventListener('change', applyFilters);
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      if (hubSelect) hubSelect.value = 'all';
      if (speciesSelect) speciesSelect.value = 'all';
      applyFilters();
    });
  }

  restoreFromUrl();
  applyFilters();

  /* ---- Load the rest of the corpus -------------------------------------
     Shopify caps `blog.articles` at 50 per page and its `paginate ... by`
     tag also maxes out at 50, so page 1 renders only the first 50 guides.
     Filtering is client-side over cards in the DOM, so without this the
     search and the hub/species dropdowns would silently only ever match
     the first 50 — worse than paginating, because it looks complete.

     So: fetch the remaining pages, lift their cards into the grid, then
     re-run the filter. Done sequentially and appended in page order to keep
     the corpus in its published order.

     Fails soft — if a fetch dies, you keep the 50 already rendered rather
     than an empty grid. */
  function hydrateRemainingPages() {
    var totalPages = parseInt(grid.getAttribute('data-bb-library-pages') || '1', 10);
    var blogUrl = grid.getAttribute('data-bb-library-url') || window.location.pathname;
    if (!totalPages || totalPages < 2 || typeof window.fetch !== 'function') return;

    var pending = [];
    for (var p = 2; p <= totalPages; p++) pending.push(p);

    pending.reduce(function (chain, pageNum) {
      return chain.then(function () {
        return fetch(blogUrl + '?page=' + pageNum, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var incoming = doc.querySelectorAll('[data-bb-library-grid] [data-bb-hub]');
            for (var i = 0; i < incoming.length; i++) {
              var node = document.importNode(incoming[i], true);
              /* the reveal class animates on scroll; new cards arrive after
                 the observer has already run, so show them outright */
              node.classList.remove('bb-reveal');
              grid.appendChild(node);
              cards.push(node);
            }
          })
          .catch(function () { /* keep what we have */ });
      });
    }, Promise.resolve()).then(function () {
      applyFilters();
    });
  }

  hydrateRemainingPages();

})();
